import NpawPlugin from './NpawPlugin';
import 'core-js/actual/url';
// Expose react-native's AppState to the (shared) background detector. That detector is also
// compiled into the browser build, so it cannot import 'react-native' itself; here in the RN
// entry 'react-native' is a webpack external that Metro resolves at runtime.
try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const reactNative = require('react-native');
    if (reactNative && reactNative.AppState) {
        global.__NPAW_APP_STATE__ = reactNative.AppState;
    }
}
catch (e) {
    /* react-native unavailable: background auto-detection stays DOM-only */
}
export default NpawPlugin;
